// extracted by mini-css-extract-plugin
export var defaultWrapper = "_l3-3";
export var downloadButton = "_l3-4";
export var fileContainer = "_l3-9 _l3-7";
export var fileContainerBase = "_l3-7";
export var fileContainerFixedHeight = "_l3-8 _l3-7";
export var fileInfo = "_l3-5";
export var fileInfoWidthRestricted = "_l3-6";
export var fileType = "_l3-1";
export var fileTypeName = "_l3-2";
export var image = "_l3-0";
export var link = "_l3-b";
export var overflowEllipsis = "_l3-a";